// Languages should be sorted in the same order as in the client enums.json
export const contestLanguages = [
  { label: 'All languages', value: '' },
  { label: 'C', value: 'c', icon: <i className="devicon-c-plain colored mr-1"></i> },
  { label: 'C#', value: 'c_sharp', icon: <i className="devicon-csharp-plain colored mr-1"></i> },
  { label: 'C++', value: 'cpp', icon: <i className="devicon-cplusplus-plain colored mr-1"></i> },
  { label: 'Go', value: 'go', icon: <i className="devicon-go-original-wordmark colored mr-1"></i> },
  { label: 'Java', value: 'java', icon: <i className="devicon-java-plain colored mr-1"></i> },
  { label: 'Javascript', value: 'javascript', icon: <i className="devicon-javascript-plain colored mr-1"></i> },
  { label: 'Kotlin', value: 'kotlin', icon: <i className="devicon-kotlin-plain colored mr-1"></i> },
  { label: 'PHP', value: 'php', icon: <i className="devicon-php-plain colored mr-1"></i> },
  { label: 'Python', value: 'python', icon: <i className="devicon-python-plain colored mr-1"></i> },
  { label: 'Ruby', value: 'ruby', icon: <i className="devicon-ruby-plain colored mr-1"></i> },
  { label: 'Rust', value: 'rust', icon: <i className="devicon-rust-plain colored mr-1"></i> },
  { label: 'Scala', value: 'scala', icon: <i className="devicon-scala-plain colored mr-1"></i> },
  { label: 'Typescript', value: 'typescript', icon: <i className="devicon-typescript-plain colored mr-1"></i> },
];

export const Languages = {
  c: {
    EditorName: 'c_cpp',
    SimpleName: 'C',
  },
  c_sharp: {
    EditorName: 'csharp',
    SimpleName: 'C# .NET',
  },
  cpp: {
    EditorName: 'c_cpp',
    SimpleName: 'C++',
  },
  go: {
    EditorName: 'golang',
    SimpleName: 'Go',
  },
  java: {
    EditorName: 'java',
    SimpleName: 'Java',
  },
  javascript: {
    EditorName: 'javascript',
    SimpleName: 'Javascript',
  },
  kotlin: {
    EditorName: 'kotlin',
    SimpleName: 'Kotlin',
  },
  php: {
    EditorName: 'php',
    SimpleName: 'PHP',
  },
  python: {
    EditorName: 'python',
    SimpleName: 'Python',
  },
  ruby: {
    EditorName: 'ruby',
    SimpleName: 'Ruby',
  },
  rust: {
    EditorName: 'rust',
    SimpleName: 'Rust',
  },
  scala: {
    EditorName: 'scala',
    SimpleName: 'Scala',
  },
  typescript: {
    EditorName: 'typescript',
    SimpleName: 'Typescript',
  },
};
